import type { ClassPair } from '@arena/shared';

/** A fresh player's first steps in the hub, in order. */
export const STEPS = {
  class: {
    text: 'Speak with Elder Ivo to choose your two classes.',
    npcs: ['npc-class'],
  },
  spells: {
    text: 'Open your Spellbook (bottom left) to see your spells. Hover one to read it.',
    npcs: [],
  },
  practice: {
    text: 'Speak with Brakka and try your spells on the training dummies.',
    npcs: ['npc-practice'],
  },
  queue: {
    text: "When you're ready, a Battlemaster will find you a real opponent.",
    npcs: ['npc-1v1', 'npc-2v2', 'npc-3v3'],
  },
} satisfies Record<string, { text: string; npcs: string[] }>;
export type Step = keyof typeof STEPS | 'done';

/** The step after `step`, once the player has done what it asks; otherwise `step`. */
export function advance(
  step: Step,
  state: {
    classes: ClassPair | null;
    panel: string | null;
    bracket: string;
    queued: boolean;
  },
): Step {
  if (step === 'class' && state.classes) return 'spells';
  if (step === 'spells' && state.panel === 'spellbook') return 'practice';
  if (step === 'practice' && state.bracket === 'practice') return 'queue';
  if (
    step === 'queue' &&
    (state.queued || !['hub', 'practice'].includes(state.bracket))
  )
    return 'done';
  return step;
}
